import React from "react";
import { FormGroup, Input } from "reactstrap";
import Search from "assets/img/images/search.svg";
import Swap from "assets/img/images/swap.svg";
import CloseIcon from "@mui/icons-material/Close";
import "assets/css/listing-page.css";
import { useTranslation } from "context/TranslationProvider";

const SearchComponent = ({
  rotate,
  searchFrom,
  searchTo,
  isSelectedFrom,
  isSelectedTo,
  filteredCities = [],
  handleFromChange,
  handleToChange,
  handleFromCity,
  handleToCity,
  toggleFromTo,
  startDate,
  setStartDate,
  today,
  getSearchSenderListings,
  noCityMatchMessage,
  onSearchClick,
}) => {
  const toInputDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    return !isNaN(d) ? d.toISOString().split("T")[0] : "";
  };

  const dateValue = toInputDate(startDate);
  const isSwapEnabled = searchFrom && searchTo;
  const { t } = useTranslation();

  return (
    <div className="search-component">
      <div className="search-row align-items-end">
        <div className="search-field-wrapper">
          <FormGroup className="mb-0 position-relative d-flex align-items-center">
            <Input
              type="text"
              placeholder={t("page.listing.from", "From")}
              value={searchFrom}
              onChange={handleFromChange}
              className="form-control-alternative"
              style={{ paddingRight: "24px" }}
            />
            {searchFrom && (
              <span
                onClick={() => {
                  handleFromChange({ target: { value: "" } });
                }}
                className="position-absolute cursor-pointer"
                style={{
                  right: "10px",
                  color: "#8898aa",
                  zIndex: 10,
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <CloseIcon style={{ fontSize: "14px" }} />
              </span>
            )}
          </FormGroup>

          {searchFrom && !isSelectedFrom && (
            <ul className="search-dropdown">
              {filteredCities.length ? (
                filteredCities.map((city) => (
                  <li
                    key={city.id}
                    onClick={() => handleFromCity(city)}
                    className="search-dropdown-item"
                  >
                    {city.name} – {city.state_name}, {city.country_name}
                  </li>
                ))
              ) : (
                <li className="search-dropdown-item">
                  {noCityMatchMessage}
                </li>
              )}
            </ul>
          )}
        </div>
        <div
          onClick={() => {
            if (!searchFrom || !searchTo) return;
            toggleFromTo();
          }}
          className={`swap-button ${!isSwapEnabled ? "swap-button--disabled" : ""}`}
        >
          <img
            src={Swap}
            alt="swap"
            className={`swap-icon ${rotate ? "swap-icon--rotated" : ""}`}
          />
        </div>
        <div className="search-field-wrapper">
          <FormGroup className="mb-0 position-relative d-flex align-items-center">
            <Input
              type="text"
              placeholder={t("page.listing.to", "To")}
              value={searchTo}
              onChange={handleToChange}
              className="form-control-alternative"
              style={{ paddingRight: "24px" }}
            />
            {searchTo && (
              <span
                onClick={() => {
                  handleToChange({ target: { value: "" } });
                }}
                className="position-absolute cursor-pointer"
                style={{
                  right: "10px",
                  color: "#8898aa",
                  zIndex: 10,
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <CloseIcon style={{ fontSize: "14px" }} />
              </span>
            )}
          </FormGroup>

          {searchTo && !isSelectedTo && (
            <ul className="search-dropdown">
              {filteredCities.length ? (
                filteredCities.map((city) => (
                  <li
                    key={city.id}
                    onClick={() => handleToCity(city)}
                    className="search-dropdown-item"
                  >
                    {city.name} – {city.state_name}, {city.country_name}
                  </li>
                ))
              ) : (
                <li className="search-dropdown-item">
                  {noCityMatchMessage}
                </li>
              )}
            </ul>
          )}
        </div>

        <div className="date-field">
          <FormGroup className="mb-0 position-relative d-flex align-items-center">
            <Input
              type="date"
              value={dateValue}
              onChange={(e) => setStartDate(e.target.value)}
              className="form-control-alternative"
              style={{ paddingRight: "48px" }}
            />
            {startDate && (
              <span
                onClick={() => {
                  setStartDate(undefined);
                }}
                className="position-absolute cursor-pointer"
                style={{
                  right: "32px",
                  color: "#8898aa",
                  zIndex: 10,
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <CloseIcon style={{ fontSize: "14px" }} />
              </span>
            )}
          </FormGroup>
        </div>

        <button
          type="button"
          onClick={onSearchClick}
          className="search-button"
        >
          <img src={Search} alt="search" className="search-icon" />
        </button>
      </div>
    </div>
  );
};

export default SearchComponent;
